<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    if(sessionStorage.getItem("userInfo")){
      this.$store.commit('setUserInfo',sessionStorage.getItem("userInfo"))
      sessionStorage.removeItem("userInfo")
    }else{
      this.$store.commit('setUserInfo',null)
      sessionStorage.removeItem("userInfo")
    }
    if(sessionStorage.getItem("token")){
      this.$store.commit('setToken',sessionStorage.getItem("token"))
      sessionStorage.removeItem("token")
    }else{
      this.$store.commit('setToken',null)
      sessionStorage.removeItem("token")
    }
  },
  mounted() {
    let that = this;
    window.addEventListener('beforeunload', e => {
      if(that.$store.state.userInfo){
        sessionStorage.setItem("userInfo",JSON.stringify(that.$store.state.userInfo))
      }
      if(that.$store.state.token){
        sessionStorage.setItem("token",that.$store.state.token)
      }
    });
  }
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  overflow: auto;
  // color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    // color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
